import styled from 'styled-components';
import { Link } from 'react-static';
import Toolbar from '@material-ui/core/Toolbar';
import IcoLogoNovemberfive from 'app/components/icons/IcoLogoNovemberfive';

export const ToolbarStyled = styled(Toolbar)`
  padding: 15px;
  min-height: initial !important;
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 0;
`;

export const LinkStyled = styled(Link)`
  text-decoration: none;
  ${({ theme }) => theme.textStyles.heading01global01};
`;

export const IcoLogoNovemberfiveStyled = styled(IcoLogoNovemberfive)`
  width: 30px;
  height: 30px;
  fill: ${props => props.theme.palette.global01};
  display: block;
  position: absolute;
  right: 15px;
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Page/Page.styled.js